/***
 **Module Name: category
 **File Name :  category.js
 **Project :    Orasi Media
 **Copyright(c) : X Platform Consulting.
 **Organization : Peafowl Inc
 **author :  chandrasekhar
 **author :  Hari
 **license :
 **version :  1.0.0
 **Created on :
 **Created on: Dec 29 2022
 **Last modified on: Dec 29 2022
 **Description : contains category page details.
 ***/
import React, { useState, useEffect, useRef, useContext } from "react";
import tmdbApi from "../api/tmdbApi";
import { useNavigate } from "react-router";
import Select from 'react-select';
import { contentContext } from "../context/contentContext";
import Modal from 'react-bootstrap/Modal';
import InactivePopup from "./inactivePopup";
import SessionPopup from "./SessionPopup";
import moment from "moment";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { blacklist } from "validator";

const AdvanceSearch = ({ advSearchCall, selectedData, categoryData }) => {
  const navigate = useNavigate();
  const [lookup, setLookUp] = useState({});
  const [categoryError, setCategoryError] = useState("");
  const [success, setSuccess] = useState(false);
  const [errorMsg, setErrorMsg] = useState({});
  let { lambda, appname } = window.app;

  const { searchPayload, setShowSessionPopupup, searchId, setSearchId, showSessionPopupup, inactiveFlag, setInactiveFlag, setSearchPayload, Categories, categoryName1, setInitialCategoriesData1, setPageNumber, setPerpage, setShowCategoryData, setSearchFunActive, setIsLoading, setMenuCategoryName, isLoading, setParamType, setCategorySearchPayload, setTitleSearchPayload, SetSearchTitleInput, selectedOptions, setSelectedOptions, setFormValuesForContent, setCategoryFields, setContentSearchFlag,
  } = useContext(contentContext)
  const booleanOptions = [
    { value: "", label: "Select" },
    { value: "true", label: "True" },
    { value: "false", label: "False" },
  ];

  const formatEmailCall = () => {
    try {

      const clientid = localStorage.getItem("clientid")
      axios({
        method: 'POST',
        url: lambda + "/formatEmail?appname=" + appname + "&clientid=" + clientid,
      })
        .then(function (response) {
          if (response.data.result == "Invalid token or Expired") {
            setShowSessionPopupup(true)
          } else if (response.data.result == "Client inactived") {
            setInactiveFlag(true)

          } else {


            console.log(response)
          }
        });

    } catch {
      console.log("format email error");
    }
  }
  function onConfirm() {
    setSuccess(false)
    formatEmailCall()
  };

  const returnArray = (arr) => {
    let arr2 = []
    arr.map((eachItem) => {
      arr2.push(eachItem.value)
    })
    return arr2
  }


  const handleMultiSelect = (selected, key) => {
    setSearchId("")
    let selectedArray = returnArray(selected)
    const updatedObject = { ...searchPayload, [key]: selectedArray };

    // Iterate through the keys of the object
    for (const key in updatedObject) {
      if (updatedObject.hasOwnProperty(key)) {
        const value = updatedObject[key];

        // Check if the value is an empty string, empty array, or undefined
        if (value === '' || (Array.isArray(value) && value.length === 0) || value === undefined) {
          // Delete the key from the object
          delete updatedObject[key];
        }
      }
    }
    console.log("multiselect---->", updatedObject)
    setSearchPayload(updatedObject)
  };




  useEffect(() => {
    if (!localStorage.getItem("token")) {
      navigate("/");
    }
    Categories();
    GetLookUp();
  }, []);

  useEffect(() => {
    if (selectedData?.name) {
      setSearchPayload((prevPayload) => ({
        ...prevPayload,
        category: [selectedData.name],
      }));

      console.log("selectedddddd", selectedData)
      console.log("searchPayload---->", searchPayload)
    }
  }, [selectedData]);

  const handleClear = () => {
    setSearchPayload({})
    setErrorMsg({})
    setSelectedOptions([])
    setShowCategoryData(true)
    setSearchId("")
    setMenuCategoryName("")
    setPerpage(18)
    setPageNumber(1)
    setParamType("")
    setFormValuesForContent([])

  }

  const convertValues = () => {
    let obj = { ...searchPayload }


    if (searchPayload.hasOwnProperty('noofepisodes')) {
      obj = {
        ...obj,
        noofepisodes: {
          ...(searchPayload.noofepisodes.noofepisodesfrom?.length > 0 && {
            noofepisodesfrom: parseInt(searchPayload.noofepisodes.noofepisodesfrom)
          }),
          ...(searchPayload.noofepisodes.noofepisodesto?.length > 0 && {
            noofepisodesto: parseInt(searchPayload.noofepisodes.noofepisodesto)
          })
        }
      };



    }

    if (Array.isArray(searchPayload.typeofrights) && (searchPayload.typeofrights.includes('AVOD') ||
      searchPayload.typeofrights.includes('SVOD') ||
      searchPayload.typeofrights.includes('TVOD'))) {
      obj = { ...obj, typeofrights: [...new Set([...searchPayload.typeofrights, "Digital", "OTT"])] };

    }
    if (Array.isArray(searchPayload.typeofrights) && (searchPayload.typeofrights.includes('Digital') ||
      searchPayload.typeofrights.includes('OTT'))) {
      obj = { ...obj, typeofrights: [...new Set([...searchPayload.typeofrights, "OTT", "AVOD", "SVOD", "TVOD", "Digital"])] };

    }



    if (searchPayload.hasOwnProperty('languages')) {
      obj = { ...obj, dubbinglanguages: searchPayload.languages }
    }
    if (searchPayload.hasOwnProperty('releaseyear')) {
      obj = { ...obj, releaseyear: parseInt(searchPayload.releaseyear) }
    }
    if (searchPayload.hasOwnProperty('noofseasons')) {
      obj = { ...obj, noofseasons: parseInt(searchPayload.noofseasons) }
    }


    if (searchPayload.hasOwnProperty('IMDBrating')) {
      obj = { ...obj, IMDBrating: parseFloat(searchPayload.IMDBrating) }
    }
    if (searchPayload.hasOwnProperty('availabilityofscripts')) {
      obj = { ...obj, availabilityofscripts: searchPayload.availabilityofscripts.toLowerCase() === "true" }
    }
    if (searchPayload.hasOwnProperty('isMEavailable')) {
      obj = { ...obj, isMEavailable: searchPayload.isMEavailable.toLowerCase() === "true" }
    }

    return obj
  }
  const searchSubmit = async () => {
    const isValid = validateSearchData();
    if (isValid) {
      try {
        let payload = convertValues();

        setInitialCategoriesData1([]);
        setContentSearchFlag(true);
        setIsLoading(true);
        setSearchFunActive(true);
        setMenuCategoryName("");
        setPerpage(18);
        setPageNumber(1);
        SetSearchTitleInput("");
        setParamType("advancedSearch");
        setCategorySearchPayload({});
        setTitleSearchPayload({});
        setSearchPayload(searchPayload);

        advSearchCall(payload);
      } catch (error) {
        console.error("Error in searchSubmit:", error);
      }
    }
  };






  const validateSearchData = () => {
    let formIsValid = true;
    let error = { ...errorMsg };

    if (parseInt(searchPayload.noofepisodes?.noofepisodesfrom) >= parseInt(searchPayload.noofepisodes?.noofepisodesto)) {
      error['noofepisodesfrom'] = `max value should be greater than the min value`;

      formIsValid = false;
    }


    setErrorMsg(error);
    return formIsValid;
  };



  const onChangeSearch = (e) => {
    const { name, value } = e.target;
    setSearchId("")
    const updatedObject = { ...searchPayload };
    const regex = /^[0-9]+(\.[0-9]{0,1})?$/;

    if (name === "IMDBrating") {
      const parsedValue = parseFloat(value);
      if (value === '' || (regex.test(value) && parsedValue >= 1 && parsedValue <= 10)) {
        updatedObject[name] = value;
      } else {
        delete updatedObject[name];
      }
    } else if (name === "noofepisodesfrom" || name === "noofepisodesto") {
      setErrorMsg({})
      if (value === '' || regex.test(value)) {
        updatedObject.noofepisodes = {
          ...updatedObject.noofepisodes,
          [name]: value,
        };


        if (!updatedObject.noofepisodes.noofepisodesfrom && !updatedObject.noofepisodes.noofepisodesto) {
          delete updatedObject.noofepisodes;
        }
      } else {
        delete updatedObject.noofepisodes[name];
      }
    }
    else if (name === "noofseasons") {
      if (value === '' || (regex.test(value) && parseFloat(value) >= 1)) {
        updatedObject[name] = value;
      } else {
        delete updatedObject[name];
      }
    } else {
      updatedObject[name] = value;
    }

    // Iterate through the keys of the object
    for (const key in updatedObject) {
      if (updatedObject.hasOwnProperty(key)) {
        const value = updatedObject[key];

        // Check if the value is an empty string, empty array, or undefined
        if (value === '' || (Array.isArray(value) && value.length === 0) || value === undefined) {
          // Delete the key from the object
          delete updatedObject[key];
        }
      }
    }

    setSearchPayload(updatedObject);

  };




  const GetLookUp = async (e) => {
    try {
      let arrayType = ["country", "territories", "genre", "videoformat", "resolution", "musicgenre", "rights", "cuisine", "sports", "certificate", "language"];

      const response = await tmdbApi.getLookUp({
        type: arrayType,
        "sortBy": "name"

      });
      console.log(response);
      if (response.statusCode == 200) {
        let arrayType = ["country", "territories", "genre", "videoformat", "resolution", "musicgenre", "rights", "cuisine", "sports", "certificate", "language"];

        let lookupsData = response.result || []

        arrayType.map((eachItem) => {
          let arr1 = []
          lookupsData.map((item1) => {
            if (item1.type == eachItem) {
              arr1.push(item1.name)
            }
          });
          lookup[eachItem] = arr1
          setLookUp({ ...lookup });
        })
        // console.log('lookup', lookup)

      }

    } catch {
      console.log("error");
    }
  }


  const k = categoryName1.map(eachh => eachh.value)
  let defaultFields = ['dubbinglanguages', 'languages', 'typeofrights', 'genre', 'videoquality', 'territoriesavailable', 'releaseyear']

  var fields = [];
  let selectedCategory = (searchPayload?.category === undefined || searchPayload?.category.length <= 0) ? k : searchPayload?.category

  const results = categoryData.filter(({ name: item }) => selectedCategory.includes(item));



  const kArr = results.map(eachItem => {
    const kk = Object.keys(eachItem.fields).map(subItem => {
      // Iterate through the original array
      const existingObjectIndex = fields.findIndex(obj => obj.name === eachItem.fields[subItem].name);

      // Check if the current object has mandatory: true
      if (eachItem.fields[subItem].mandatory) {
        // If there's an existing object with the same name, replace it with the current object
        if (existingObjectIndex !== -1) {
          fields[existingObjectIndex] = eachItem.fields[subItem];
        } else {
          fields.push(eachItem.fields[subItem]);
        }
      } else if (existingObjectIndex === -1) {
        // If the current object has mandatory: false and no existing object with the same name, add it
        fields.push(eachItem.fields[subItem]);
      }


    })

  })

  // fields = fields.filter(each => each.searchable)
  if ((searchPayload?.category === undefined || searchPayload?.category.length <= 0)) {
    const filterFields = fields.filter(({ name: item }) => defaultFields.includes(item));
    fields = filterFields;

  } else {
    fields = fields.filter(each => each.searchable)
  }




  const handleChange = (selected, isFormatSigned) => {
    setErrorMsg({})
    setSearchId("")

    console.log('handle change ', selected.value)
    var isFormatSigned = true;
    let selectedArray = []
    let k = selected.value

    categoryData.map((item) => {
      if (item.name === "FORMATS") {
        let signed = localStorage.getItem("signed");
        if (signed === "false" || signed == undefined || signed == 'undefined' || signed === "") {
        } else {
          if (item.name === k) {
            setCategoryFields(item.fields);
          }
        }
      }
      else {
        if (item.name === k) {
          setCategoryFields(item.fields);
        }
      }

    });

    if (k === "FORMATS") {
      let signed = localStorage.getItem("signed");
      if (signed === "false" || signed == undefined || signed == 'undefined' || signed === "") {
        setSuccess(true);
        isFormatSigned = false
      } else {
        selectedArray.push(k)
        isFormatSigned = true
      }
    } else {
      selectedArray.push(k)
    }

    if (selectedArray.length > 0) {
      console.log('searchpayload', searchPayload['category'])
      console.log('selectedArray', selectedArray)
      searchPayload['category'] = selectedArray
      searchPayload['noofepisodes'] = {}
      delete searchPayload.noofepisodes;

    }

    setCategoryError("")
    // setSearchPayload({ ...searchPayload })
    if (isFormatSigned === true) {
      setSelectedOptions(selected);
    }


    const ks = categoryName1.map(eachh => eachh.value)

    var fields = [];
    let selectedCategory = (searchPayload?.category === undefined || searchPayload?.category.length <= 0) ? ks : searchPayload?.category
    const results = categoryData.filter(({ name: item }) => selectedCategory.includes(item));


    const kArr = results.map(eachItem => {
      const kk = Object.keys(eachItem.fields).map(subItem => {
        // Iterate through the original array
        const existingObjectIndex = fields.findIndex(obj => obj.name === eachItem.fields[subItem].name);

        // Check if the current object has mandatory: true
        if (eachItem.fields[subItem].mandatory) {
          // If there's an existing object with the same name, replace it with the current object
          if (existingObjectIndex !== -1) {
            fields[existingObjectIndex] = eachItem.fields[subItem];
          } else {
            fields.push(eachItem.fields[subItem]);
          }
        } else if (existingObjectIndex === -1) {
          // If the current object has mandatory: false and no existing object with the same name, add it
          fields.push(eachItem.fields[subItem]);
        }


      })

    })
    fields = fields.filter(each => each.searchable)
    let tempSearchPayload = { ...searchPayload }
    console.log('tempsearch payload==>', tempSearchPayload)
    console.log('fields  array==>', fields)
    const filteredPayload = Object.keys(searchPayload)
      .filter(key => fields.some(item => item.name === key))
      .reduce((obj, key) => {
        obj[key] = searchPayload[key];
        return obj;
      }, {});


    console.log('filteredPayload in useeffect---->', filteredPayload);
    const updatedObject = { ...filteredPayload };

    // Iterate through the keys of the object
    for (const key in updatedObject) {
      if (updatedObject.hasOwnProperty(key)) {
        const value = updatedObject[key];

        // Check if the value is an empty string, empty array, or undefined
        if (value === '' || (Array.isArray(value) && value.length === 0) || value === undefined) {
          // Delete the key from the object
          delete updatedObject[key];
        }
      }
    }

    setSearchPayload(updatedObject)

  };
  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#0E0E0E",
      borderColor: "#2c2c2c",

      boxShadow: "none",
      "&:hover": { borderColor: "#2c2c2c" },
    }),

    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#0E0E0E",
      borderColor: "#535353", // only border change
      borderWidth: "1px",
      borderStyle: "solid",

    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "#ffffff",
      fontSize: "0.75em",
    }),

    singleValue: (provided) => ({
      ...provided,
      color: "#ffffff",
    }),

  };
  const customStyles1 = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#0E0E0E",
      borderColor: "#2c2c2c",

      boxShadow: "none",
      "&:hover": { borderColor: "#2c2c2c" },
    }),

  };
  return (
    <>
      {inactiveFlag && <InactivePopup />}
      {!inactiveFlag && showSessionPopupup && <SessionPopup />}

      <Modal className="access-denied" show={success} >

        <div className="modal-body enquiry-form">
          <div className="container">
            <button className="close-btn" onClick={e => onConfirm()}><span className="material-icons">close</span></button>
            <span className="material-icons access-denied-icon">https</span>
            <h3>Access Denied</h3>
            <p>You are not eligible to view this content.</p>
            <p>Please contact administrator</p>
            <button className="fill_btn yellow-gradient" data-bs-toggle="modal" data-bs-target="#recommendModal" onClick={e => onConfirm()}>close</button>
          </div>
        </div>

      </Modal>


      <div className="left-block adv_search" id="adv-search-block">
        <div className="adv_header" id="adv-search-header">
          <h6 id="adv-search-title">
            <span className="material-symbols-outlined" id="adv-search-icon">search</span>
            Advanced Search
          </h6>
        </div>

        <div className="adv_body" id="adv-search-body">
          <div className="adv_body-inner" id="adv-search-body-inner">
            <div className="form-group" id="adv-category-group">
              <label htmlFor="adv-category-select" className="col-form-label">Category</label>
              <Select
                id="adv-category-select"
                isMulti={false}
                inputId="category-select"
                placeholder='Select Category'
                onChange={handleChange}
                options={categoryName1}
                isDisabled={isLoading}
                value={searchPayload && searchPayload['category'] && Array.isArray(searchPayload['category'])
                  ? searchPayload['category']?.map((eachItem) => { return { value: eachItem, label: eachItem } })
                  : []}
                styles={customStyles1}
              />
              <span className="errormsg" id="adv-category-error" style={{ fontWeight: 'bold', color: 'red' }}>{categoryError}</span>
            </div>

            <div className="form-group" id="adv-title-group">
              <label htmlFor="txtAdvSearchTitle" className="col-form-label">Title</label>
              <input
                type="text"
                className="form-control for-clear"
                id="txtAdvSearchTitle"
                name="title"
                placeholder="Title"
                disabled={isLoading}
                onChange={(e) => onChangeSearch(e)}
                value={searchPayload?.title || ""}
              />
            </div>

            {fields && fields.map((eachfield) => {
              if (eachfield.inputtype === "multiselectdropdown"
                && eachfield.name !== 'category'
                && eachfield.name !== 'dubbinglanguages') {
                return (
                  <div className="form-group" key={eachfield.name} id={`adv-${eachfield.name}-group`}>
                    <label htmlFor={`adv-${eachfield.name}-select`} className="col-form-label">
                      {eachfield.name === "languages" ? "Languages (Original & Dubbed)" : eachfield.display}
                    </label>

                    <Select
                      isMulti={true}
                      placeholder={"Select " + eachfield.display}
                      inputId={`adv-${eachfield.name}-select`}
                      className="mul-cls"
                      isDisabled={isLoading}
                      onChange={(e) => handleMultiSelect(e, eachfield.name)}
                      options={lookup && lookup[eachfield.lookupvalue] && lookup[eachfield.lookupvalue].map((eachItem) => { return { value: eachItem, label: eachItem } })}
                      value={searchPayload && searchPayload[eachfield.name] && Array.isArray(searchPayload[eachfield.name])
                        ? searchPayload[eachfield.name]?.map((eachItem) => { return { value: eachItem, label: eachItem } })
                        : []}
                      styles={customStyles}
                    />
                  </div>
                );
              }
            })}

            {fields && fields.map((eachfield) => {
              if ((eachfield.inputtype === 'text' || eachfield.inputtype === "number") && eachfield.name != 'title') {
                return (
                  <div className="form-group" id={`adv-${eachfield.name}-group`}>
                    <label htmlFor={`adv-${eachfield.name}-input`} className="col-form-label">{eachfield.display}</label>

                    {eachfield.name === "releaseyear" ? (
                      <>

                        {/* <span id="adv-releaseyear-onwards">onwards</span> */}
                        <div className="onwards" id="adv-releaseyear">
                          {/* <input
                    type={eachfield.inputtype}
                    name={eachfield.name}
                    className="form-control for-clear"
                    id="adv-releaseyear-input"
                    disabled={isLoading}
                    placeholder={'Enter ' + eachfield.display}
                    value={searchPayload[eachfield.name] || ""}
                    onChange={(e) => onChangeSearch(e)}
                  /> */}
                          <div className="datepicker-wrapper">
                            <DatePicker
                              id="releaseyear"
                              name="releaseyear"
                              selected={searchPayload[eachfield.name] ? new Date(searchPayload[eachfield.name], 0) : null}
                              onChange={(date) => {
                                onChangeSearch({
                                  target: {
                                    name: "releaseyear",
                                    value: date ? date.getFullYear().toString() : "",
                                  },
                                });
                              }}
                              placeholderText="Select year"
                              showYearPicker
                              dateFormat="yyyy"
                              className="form-control custom-datepicker-input"
                              minDate={new Date(1900, 0, 1)}
                              maxDate={new Date(new Date().getFullYear(), 11, 31)}
                              isClearable
                            />
                            <span id="adv-releaseyear-onwards">onwards</span>
                          </div>

                        </div>

                      </>


                    ) : eachfield.name === "noofepisodes" ? (
                      <div className="d-flex episodes" id="adv-noofepisodes">
                        <input
                          type="number"
                          name="noofepisodesfrom"
                          className="form-control for-clear"
                          id="input-noofepisodesfrom"
                          disabled={isLoading}
                          placeholder="Min episodes"
                          value={searchPayload?.noofepisodes?.noofepisodesfrom?.length > 0 && searchPayload?.noofepisodes?.noofepisodesfrom || ""}
                          onChange={(e) => onChangeSearch(e)}
                        />
                        <input
                          type="number"
                          name="noofepisodesto"
                          className="form-control for-clear"
                          id="input-noofepisodesto"
                          disabled={isLoading}
                          placeholder="Max episodes"
                          value={searchPayload?.noofepisodes?.noofepisodesto?.length > 0 && searchPayload?.noofepisodes?.noofepisodesto || ""}
                          onChange={(e) => onChangeSearch(e)}
                        />
                        {errorMsg?.noofepisodesfrom &&
                          <span className="errormsg" id="adv-noofepisodes-error" style={{ fontWeight: 'bold', color: 'red' }}>{errorMsg?.noofepisodesfrom}</span>
                        }
                      </div>
                    ) : (
                      <input
                        type={eachfield.inputtype}
                        name={eachfield.name}
                        className="form-control for-clear"
                        id={`adv-${eachfield.name}-input`}
                        disabled={isLoading}
                        placeholder={'Enter ' + eachfield.display}
                        value={searchPayload[eachfield.name] || ""}
                        onChange={(e) => onChangeSearch(e)}
                      />
                    )}
                  </div>
                )
              }
            })}

            {fields && fields.map((eachfield) => {
              if (eachfield.inputtype === "date" && eachfield.searchable === true) {
                return (
                  <div className="form-group" id={`adv-${eachfield.name}-group`}>
                    <label htmlFor={`adv-${eachfield.name}-input`} className="col-form-label">{eachfield.display}</label>
                    <input
                      placeholder={'Enter ' + eachfield.display}
                      type={eachfield.inputtype}
                      name={eachfield.name}
                      id={`adv-${eachfield.name}-input`}
                      value={searchPayload && searchPayload[eachfield.name] && moment(new Date(searchPayload[eachfield.name])).format('YYYY-MM-DD') || ""}
                      onChange={(e) => onChangeSearch(e)}
                      className="form-control for-clear date_input"
                      max={new Date().toISOString().split('T')[0]}
                    />
                  </div>
                )
              }
            })}

            {fields && fields.map((eachfield) => {
              if (eachfield.inputtype === "dropdown" && eachfield.searchable === true) {
                return (
                  <div className="form-group" id={`adv-${eachfield.name}-group`}>
                    <label htmlFor={`adv-${eachfield.name}-select`} className="col-form-label">{eachfield.display}</label>
                    {/* <select
                      className="form-select"
                      id={`adv-${eachfield.name}-select`}
                      placeholder={"Select " + eachfield.display}
                      name={eachfield.name}
                      value={searchPayload[eachfield.name]}
                      onChange={(e) => onChangeSearch(e)} >
                      <option value="">Select</option>
                      <option value="false">False</option>
                      <option value="true">True</option>
                    </select> */}
                    <Select
                      id={`adv-${eachfield.name}-select`}
                      name={eachfield.name}
                      value={booleanOptions.find(
                        (opt) => opt.value === String(searchPayload[eachfield.name] ?? "")
                      )}
                      onChange={(selectedOption) =>
                        onChangeSearch({
                          target: {
                            name: eachfield.name,
                            value: selectedOption ? selectedOption.value : "",
                          },
                        })
                      }
                      options={booleanOptions}
                      customStyles={customStyles}
                      placeholder={"Select " + eachfield.display}
                      classNamePrefix="react-select"

                    />
                  </div>
                )
              }
            })}

            {fields && fields.map((eachfield) => {
              if (eachfield.inputtype === "textarea" && eachfield.searchable === true) {
                return (
                  <div className="form-group" id={`adv-${eachfield.name}-group`}>
                    <label htmlFor={`adv-${eachfield.name}-textarea`} className="col-form-label">{eachfield.display}</label>
                    <textarea
                      id={`adv-${eachfield.name}-textarea`}
                      placeholder={"Enter " + eachfield.display}
                      name={eachfield.name}
                      type="text"
                      className="form-control"
                      value={searchPayload[eachfield.name]}
                      onChange={(e) => onChangeSearch(e)}
                    />
                  </div>
                )
              }
            })}

          </div>
        </div>

        <div className="adv_footer" id="adv-search-footer">
          <button type="button" className="clear-btn line-btn" id="adv-clear-btn" onClick={handleClear}>
            <span className="material-icons me-1" id="adv-clear-icon">autorenew</span>reset
          </button>

          <button
            id="adv-search-btn"
            className={`fill_btn yellow-gradient float-end ${Object.keys(searchPayload).length == 0 ? "disable" : ""}`}
            disabled={Object.keys(searchPayload).length == 0}
            onClick={searchSubmit}
          >
            SEARCH
          </button>
          <div className="clearfix" id="adv-search-clearfix"></div>
        </div>
      </div>


    </>
  );
};

export default AdvanceSearch;
